import { useDispatch } from 'react-redux';
import { useNotificationChannel } from '@dotone/react-ui-core/hooks';
import { fetchUnreadNotifications, receiveNotification } from '@actions';

const NotificationChannel = () => {
  const dispatch = useDispatch();

  useNotificationChannel({
    onReceive: (notificationData) => dispatch(receiveNotification(notificationData)),
    onReconnect: ({ locale: reconnectLocale }) =>
      dispatch(fetchUnreadNotifications({ locale: reconnectLocale })),
  });

  return null;
};

export default NotificationChannel;
